const MOBILE_BREAKPOINT = 730
export const desktop = `@media screen and (min-width: ${MOBILE_BREAKPOINT + 1}px)`
export const mobile = `@media screen and (max-width: ${MOBILE_BREAKPOINT}px)`
